import {Component} from '@angular/core';
import {ClienteService} from "../../../services/cliente.service";
import {ToastrService} from "ngx-toastr";
import {DatePipe} from "@angular/common";
import {ListaPessoa} from "../../../models/lista-pessoa";
import {ItemPessoa} from "../../../models/item-pessoa";

@Component({
    selector: 'app-lista',
    templateUrl: './lista.component.html',
    styleUrl: './lista.component.css',
    standalone: false
})
export class ListaComponent {
  loading = true;
  public colunas = ['id', `Nome`, 'Telefone', 'Tipo Documento', 'Documento', 'Ativo'];
  public linhas: any[] = [];
  listaClientes = new ListaPessoa();
  habilitarNovo = false;

  constructor(private clienteService: ClienteService,
              private toastr: ToastrService,
              private datePipe: DatePipe) {
    this.buscarListaClientes();
  }

  public abrirModalNovo(){
    this.habilitarNovo = true;
  }

  public fecharModalNovo(){
    this.habilitarNovo = false;
    this.buscarListaClientes();
  }

  buscarListaClientes(){
    this.loading = true;
    this.listaClientes = new ListaPessoa();
    this.linhas = [];
    this.clienteService.selecionarLista().subscribe(response => {
      if(response.sucesso){
        this.listaClientes = response.dados;
        this.preencherLista(response.dados.itens);
        this.loading = false;
      }
    }, error =>{
      if(error.status === 404){
        this.toastr.warning("Lista de clientes vazia");
      }
      else{
        this.toastr.error("Erro ao buscar a listagem - HTTP " + error.status );
      }
      this.loading = false;
    });
  }

  private preencherLista(listaItens: ItemPessoa[]){
    for(let item of listaItens) {
      let stringArray: string[] = [];
      let status = '';

      if(item.ativo)
        status = 'Ativo';
      else
        status = 'Desativado';



      stringArray.push(item.id.toString(), item.nome, item.telefone,  item.tipoDocumentoDescricao, item.documento, status);
      this.linhas.push(stringArray);
    }
  }
}
